import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

import { AppearanceIncoming } from './types';

export type StoreState = {
  customAppearance: AppearanceIncoming;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
};

const initialState: StoreState = {
  customAppearance: {} as AppearanceIncoming,
  hasData: false,
  isLoading: false,
  failedToLoad: false,
};

export enum AppearanceActionKeyPrefixes {
  FETCH_APPEARANCE = 'appearance/fetchAppearance',
}

export type AppearancePayload = {
  customAppearance: AppearanceIncoming;
};

export const getCustomAppearance = async (): Promise<AppearanceIncoming> =>
  await fetchFromOldApi(`/json/custom/appearance `).then((r) => r.json());

export const fetchCustomAppearance = createAsyncThunk<
  AppearancePayload,
  undefined
>(
  AppearanceActionKeyPrefixes.FETCH_APPEARANCE,
  async (): Promise<AppearancePayload> => {
    return {
      customAppearance: await getCustomAppearance(),
    };
  },
);

export const appearanceSlice = createSlice({
  name: '~/data/appearance',
  initialState,
  reducers: {
    updateCustomAppearance: (
      state: StoreState,
      action: PayloadAction<AppearanceIncoming>,
    ) => {
      state.customAppearance = action.payload;
    },
  },
  extraReducers: {
    [fetchCustomAppearance.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<AppearancePayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.hasData = true;
      state.customAppearance = action.payload.customAppearance;
    },
    [fetchCustomAppearance.pending.type]: (state: StoreState) => {
      state.isLoading = false;
    },
    [fetchCustomAppearance.rejected.type]: (state: StoreState) => {
      state.isLoading = false;
      state.failedToLoad = true;
    },
  },
});
export const { updateCustomAppearance } = appearanceSlice.actions;
export const appearanceReducer = appearanceSlice.reducer;
